import React from 'react';
import VideoMockup from './VideoMockup';

const DeviceMockupVideo = ({video, poster, caption}) => (
  <span className="frame-inline">
    <div className="marvel-device iphone6 white">
        <div className="top-bar"></div>
        <div className="sleep"></div>
        <div className="volume"></div>
        <div className="camera"></div>
        <div className="sensor"></div>
        <video autoplay="true" loop="true" className="hero-vid screen">
          <source src={video} type="video/mp4"/>
        </video>
        <div className="speaker"></div>
        <div className="home"></div>
        <div className="bottom-bar"></div>
    </div>
    <div className="mobile-only">
      <div className="screen">
        <VideoMockup video={video}/>
      </div>
    </div>
  </span>
);

export default DeviceMockupVideo;



// WEBPACK FOOTER //
// ./src/layout/portfolio/DeviceMockupVideo.js